import { noPhraseSymbol } from '@/consts/noPhraseSymbol';
import { getEnvValue } from '@/utils/getEnvValue';

export const missingPhraseText = '💬 text is missing';

export const emptyPhrase = getEnvValue({ dev: missingPhraseText, prod: '' });

export const isEmptyPhrase = (phrase: string | null | undefined) =>
    !phrase || phrase === emptyPhrase || phrase === noPhraseSymbol;
